// extracted by mini-css-extract-plugin
export var dividerLine = "_6h-3";
export var itemImage = "_6h-9";
export var lightDivider = "_6h-4";
export var modalContent = "_6h-5";
export var modalContentCompact = "_6h-6";
export var productCard = "_6h-a";
export var productImage = "_6h-b";
export var productImageCompact = "_6h-7";
export var productImagePlaceholder = "_6h-c";
export var productImagePlaceholderCompact = "_6h-8";
export var progressBarBackground = "_6h-1";
export var progressBarContainer = "_6h-0";
export var progressBarFill = "_6h-2";